import React, { type JSX } from 'react'
import {
  AddCar,
  ArrowLeft,
  ArrowRight,
  Bin,
  PoundSign,
  Alert,
  AltSignIn,
  AutoTrader,
  Calculator,
  Info,
  Call,
  Close,
  Edit,
  Email,
  Favourite,
  FavouriteFill,
  Finance,
  Help,
  HelpFill,
  Home,
  Inbox,
  Menu,
  Location,
  Mobile,
  Office,
  Padlock,
  Paperwork,
  Photo,
  Search,
  SearchCars,
  SignIn,
  Tick,
  Time,
  Outline,
  ApprovedFill,
  CloseToolTip,
  CarPlaceHolder,
  AdBlockZuto
} from './src'

// const IconOptions: { [key: string]: JSX.Element; } = {
const IconOptions = (): { [key: string]: JSX.Element; } => ({
  AddCar: <AddCar />,
  Alert: <Alert />,
  AltSignIn: <AltSignIn />,
  ApprovedFill: <ApprovedFill />,
  ArrowLeft: <ArrowLeft />,
  ArrowRight: <ArrowRight />,
  AutoTrader: <AutoTrader />,
  Bin: <Bin />,
  Calculator: <Calculator />,
  Call: <Call />,
  Close: <Close />,
  Edit: <Edit />,
  Email: <Email />,
  Favourite: <Favourite />,
  FavouriteFill: <FavouriteFill />,
  Finance: <Finance />,
  Help: <Help />,
  HelpFill: <HelpFill />,
  Home: <Home />,
  Inbox: <Inbox />,
  Info: <Info />,
  Location: <Location />,
  Menu: <Menu />,
  Mobile: <Mobile />,
  Office: <Office />,
  Outline: <Outline />,
  Padlock: <Padlock />,
  Paperwork: <Paperwork />,
  Photo: <Photo />,
  PoundSign: <PoundSign />,
  Search: <Search />,
  SearchCars: <SearchCars />,
  SignIn: <SignIn />,
  Tick: <Tick />,
  Time: <Time />,
  CloseToolTip: <CloseToolTip />,
  CarPlaceHolder: <CarPlaceHolder />,
  AdBlockZuto: <AdBlockZuto />
})

export default IconOptions
